module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M20 1v6a1 1 0 0 0 1 1h6c.552 0 .684-.316.292-.708L20.706.706C20.316.316 20 .448 20 1zM9 18h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm10-8a1 1 0 0 1-1-1V1a1 1 0 0 0-1-1H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V11a1 1 0 0 0-1-1h-8z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/remove-document-1.js
// module id = 1365
// module chunks = 14